<template>
  <div>
    <v-layout
      row
      class="mb-4"
    >
      <v-flex
        xs10
        offset-xs1
        sm8
        offset-sm2
        lg6
        offset-lg3
        class="mt-5"
      >
        <v-card v-if="anfrage">
          <v-card-title
            
            class="grey lighten-4"
          >
            <h3 class="subheading mb-0">
              Status Ihrer Anfrage
            </h3>

            <!-- <v-spacer></v-spacer>
            {{ anfrage.userscount }} <v-icon right>remove_red_eye</v-icon> -->
          </v-card-title>
          <v-divider></v-divider>

          <v-card-text class="headline mt-3">Hallo {{ anfrage.name }},</v-card-text>

          <v-card-text class="subheading">

            <!-- 
              
              Ihre Anfrage zum Thema <strong>{{ anfrage.landingbezug.name }}</strong> in {{ anfrage.stadtbezug.name }}

            <span v-if="anfrage.userscount > 0">
              wurde bereits von {{ anfrage.userscount }} relevanten Betrieben gesehen.
            </span>

            <span v-else>
              wurde noch nicht von Betrieben aufgerufen.
            </span>

            <br><br> --> 

            <span v-if="anfrage.status === 0">
              Ihre Anfrage wurde noch nicht freigeschaltet. Sie können aber bereits auf unser Verzeichnis zurückzugreifen.
            </span>
            <span v-if="anfrage.status === 1">
              Sie haben die Möglichkeit, Ihre Anfrage zu beenden, oder auf unser Verzeichnis zurückzugreifen.
            </span>
            <span v-if="anfrage.status === 2">
              Ihre Anfrage wurde leider abgelehnt.
            </span>
            <span v-if="anfrage.status === 3">
              Ihre Anfrage wurde aufgeschoben.
            </span>

          </v-card-text>

          <v-card-text>
            <v-layout
              align-center
              justify-space-around
              row
              wrap
              fill-height
            >
              <v-btn
                class="accent"
                @click="dialog = !dialog; deleteevent = anfrage"
                :disabled="anfragebeendet || anfrage.status >= 2"
                large
              >
                <v-icon left>close</v-icon>
                Anfrage&nbsp;  
                  <span v-if="!anfragebeendet && anfrage.status < 2"> Beenden</span>
                  <span v-else-if="anfrage.status >= 2"> Beendet</span>
              </v-btn>

              <v-btn
                class="accent"
                large
                :to="{ name: 'Landing', params: { landing: anfrage.landingbezug.slug, stadt: anfrage.stadtbezug.name.toLowerCase() }}"
              >
                <v-icon left>list_alt</v-icon>
                Verzeichnis {{ anfrage.landingbezug.name }} in {{ anfrage.stadtbezug.name }}
              </v-btn>
            </v-layout>
          </v-card-text>

          <v-card-text>

            <v-layout
              row
              wrap
            >
              <v-flex
                xs12
                mb-2
              >
                <v-icon left>timelapse</v-icon>
                <span class="subheading">
                  
                  <span v-if="anfrage.status === 0">
                    Noch nicht freigeschaltet
                  </span>

                  <span v-if="anfrage.status === 1">
                    Freigeschaltet
                  </span>
                  <span v-if="anfrage.status === 2">
                    Anfrage abgelehnt
                  </span>

                  <span v-if="anfrage.status === 3">
                    Anfrage aufgeschoben
                  </span>
 
                  
                  <strong>
                    <timeago :datetime="anfrage.updated_at.date"></timeago>
                  </strong>,
                  erstellt <timeago :datetime="anfrage.created_at.date"></timeago>
                </span>
              </v-flex>

              <v-flex
                xs12
                my-2
              >
                <v-icon left>category</v-icon>
                <span class="subheading">
                  Thema: <strong>{{ anfrage.landingbezug.name }}</strong>
                </span>
              </v-flex>

              <v-flex
                xs12
                my-2
              >
                <v-icon left>location_on</v-icon>
                <span class="subheading">
                  Gebiet: <strong>{{ anfrage.stadtbezug.name }}</strong>
                </span>
              </v-flex>

              <v-flex
                xs12
                my-2
              >
                <v-icon left>message</v-icon>
                <span class="subheading">
                  Nachricht:
                </span>
              </v-flex>
              <v-flex
                xs12
                class="mt-1 mb-3 pa-3 subheading grey lighten-5"
              >
                <v-layout column>
                  <v-flex
                    v-for="(value, key) in anfrage.text"
                    :key="key"
                  >
                    <span v-if="isNaN(value)">
                      {{ key.charAt(0).toUpperCase() + key.slice(1) }}: <strong>{{ TrueTransform(value) }}</strong>,
                    </span>
                  </v-flex>
                </v-layout>
              </v-flex>

            </v-layout>
            <!-- <anfragen-kontakt :key="anfrage.id" :anfrage="anfrage"></anfragen-kontakt> -->
          </v-card-text>
<!-- {{ anfrage }} -->
        </v-card>
      </v-flex>

      <!-- <v-btn @click="getMeinBetrieb()">recheck</v-btn> -->

    </v-layout>

    <v-dialog
      v-model="dialog"
      max-width="500px"
    >
      <v-card v-if="deleteevent">
        <!-- <v-card-title>
          Anfrage beenden?
        </v-card-title> -->
        <v-card-text
          class="subheading"
          v-if="deleteevent.landingbezug"
        >
          Möchten Sie die Anfrage im Thema <strong>{{ deleteevent.landingbezug.name }}</strong> wirklich beenden?
        </v-card-text>
        <!-- <v-card-text>{{ deleteevent }}</v-card-text> -->
        <v-card-actions>
          <v-btn
            color="primary"
            flat
            @click="dialog=false"
          >Zurück</v-btn>
           <v-spacer></v-spacer>
          <v-btn
            color="accent"
            @click="terminloeschen(deleteevent); dialog=false"
          >
            Anfrage erledigt
          </v-btn>
         
          <!-- <v-btn
            color="accent"
            @click="terminloeschen(deleteevent); dialog=false"
          >
            Anfrage pushen
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
// import AnfragenKontakt from '~/components/anfragen/AnfragenKontakt.vue'

export default {
  components: {
    //  AnfragenKontakt
  },
  data () {
    return {
      showcontact: false,
      anfrage: '',
      busy: false,
      dialog: false,
      anfragebeendet: false,
      deleteevent: []
    }
  },
  filters: {
    pretty: function (value) {
      return JSON.stringify(JSON.parse(value), null, 2)
    }
  },
  created () {
    // this.getAnfrage()
    // this.getMeineLeistungen()
  },
  mounted () {},
  computed: {},
  beforeRouteEnter (to, from, next) {
    axios
      .get('/api/v1/anfragenstatus/' + to.params.id)
      .then(resp => {
        next(vm => {
          vm.anfrage = resp.data
          console.log(resp.data)
        })
      })
      .catch(error => {
        console.log(error)
        //  app.$router.push('/')
        // next({ name: '404' })
        // next('/404')
        next({ name: '404' })
      })
  },
  beforeRouteUpdate (to, from, next) {
    axios
      .get('/api/v1/anfragenstatus/' + to.params.id)
      .then(resp => {
        this.setData(resp.data)

        console.log(resp.data)
        // app.anzeige = resp.data
        next()
        // next(vm => (vm.anzeige = resp.data))
      })
      .catch(error => {
        console.log(error)

        //  app.$router.push('/')
        //  next({ name: '404' })
      })
  },
  methods: {
    setData (data) {
      this.anfrage = data
    },
    terminloeschen: function (item) {
      console.log(item)

      const app = this
      const itemid = item.ssid
      axios
        .delete('/api/v1/anfragebeenden/' + itemid)
        .then(function (resp) {
          // console.log(hashid)
          console.log('gelöscht: ' + itemid)
          app.$store.dispatch('responseMessage', {
            type: 'success',
            text: 'Anfrage aufgeschoben!'
          })
          // app.getKalender()
          app.anfragebeendet = true
        })
        .catch(function (error) {
          console.log(error)
          app.$store.dispatch('responseMessage', {
            type: 'error',
            text: 'Konnte Anfrage nicht aufschieben.'
          })
        })
    },
    TrueTransform: function (value) {
      if (value === true) {
        return 'gewünscht'
      } else {
        return value
      }
    }
  },
  metaInfo () {
    if (this.anfrage) {
      return {
        title:
          'Anfrage in ' +
          this.anfrage.landingbezug.name +
          ' in ' +
          this.anfrage.stadtbezug.name
      }
    }
  }
}
</script>

